<div class="animate-fadeIn">
  <div class="flex flex-col gap-10 pb-32">
    <!-- Header/Search Area -->
    <div class="flex flex-col sm:flex-row items-center justify-between gap-6">
      <div class="flex-1 max-w-md">
        <p-iconField iconPosition="left">
          <p-inputIcon styleClass="pi pi-search text-slate-400" />
          <input 
            type="text" 
            pInputText 
            [(ngModel)]="searchQuery" 
            (ngModelChange)="onSearchChange()" 
            [placeholder]="'executables_search_placeholder' | translate" 
            class="w-full !bg-white !border-slate-200 !rounded-xl !text-sm focus:!ring-2 focus:!ring-primary/10 focus:!border-primary !shadow-sm transition-all" />
        </p-iconField>
      </div>
      
      <app-button *hasPermission="'Configurações:create'"
        label="{{ 'executables_new_button' | translate }}"
        icon="pi pi-plus"
        variant="primary"
        (onClick)="openAddModal()">
      </app-button>
    </div>

    <!-- Table Container -->
    <app-prime-table
      [columns]="executableColumns"
      [data]="(executables$ | async) || []"
      [loading]="isLoadingExecutables"
      [totalRecords]="totalRecords"
      [rows]="rows"
      [paginator]="true"
      [lazy]="true"
      [templates]="templates"
      (onPage)="onPageChange($event)">
    </app-prime-table>

    <!-- Templates -->
    <ng-template #pathTemplate let-row>
      <span class="text-[10px] text-slate-500 font-mono bg-slate-50 px-2 py-1 rounded border border-slate-100 block truncate max-w-xs lg:max-w-md" [title]="row.executable_path">
        {{ row.executable_path }}
      </span>
    </ng-template>

    <ng-template #actionsTemplate let-row>
      <div class="flex justify-center">
        <button 
          (click)="op.toggle($event)"
          class="p-2 text-slate-400 hover:text-primary hover:bg-primary/5 rounded-xl transition-all">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 8a2 2 0 100-4 2 2 0 000 4zM12 14a2 2 0 100-4 2 2 0 000 4zM12 20a2 2 0 100-4 2 2 0 000 4z" />
          </svg>
        </button>
        
        <p-popover #op styleClass="custom-popover">
          <div class="w-48 py-2 font-medium">
            <button (click)="runExecutable(row.executable_path); op.hide()" class="w-full px-4 py-3 text-left text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors">
              <svg class="w-4 h-4 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path d="M5.83301 3.33334V16.6667L16.6663 10L5.83301 3.33334Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              {{ 'executables_action_run' | translate }}
            </button>
            <button (click)="copyToClipboard(row.executable_path); op.hide()" class="w-full px-4 py-3 text-left text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors">
              <svg class="w-4 h-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              {{ 'executables_action_copy' | translate }}
            </button>
            <div class="h-px bg-slate-50 my-1 mx-2"></div>
            <button *hasPermission="'Configurações:edit'" (click)="openEditModal(row); op.hide()" class="w-full px-4 py-3 text-left text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors">
              <svg class="w-4 h-4 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v14a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>
              {{ 'executables_action_edit' | translate }}
            </button>
            <button *hasPermission="'Configurações:delete'" (click)="openDeleteModal(row); op.hide()" class="w-full px-4 py-3 text-left text-[10px] font-black uppercase tracking-widest text-rose-600 hover:bg-rose-50 flex items-center gap-3 transition-colors">
              <svg class="w-4 h-4 text-rose-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1-1v3M4 7h16" /></svg>
              {{ 'executables_action_delete' | translate }}
            </button>
          </div>
        </p-popover>
      </div>
    </ng-template>

    <!-- Installers Section -->
    <div class="flex flex-col gap-8 mt-4">
      <h3 class="text-xs font-black uppercase tracking-[0.2em] text-slate-500">{{ 'executables_installers_title' | translate }}</h3>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div *ngIf="!isElectron" class="group relative bg-white rounded-[2.5rem] p-8 border border-slate-100 shadow-sm hover:shadow-md transition-all flex flex-col items-center gap-6">
          <div class="w-20 h-20 bg-primary/5 rounded-3xl shadow-sm flex items-center justify-center border border-primary/10 group-hover:scale-110 transition-all duration-500">
            <svg class="w-10 h-10 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" /></svg>
          </div>
          <div class="text-center flex flex-col gap-2">
            <p class="text-lg font-bold text-slate-800 leading-tight">{{ 'executables_card_reader_installer' | translate }}</p>
            <p class="text-[10px] text-slate-400 font-bold uppercase tracking-widest bg-slate-50 px-3 py-1 rounded-full border border-slate-100 w-fit mx-auto">{{ 'executables_card_agent_subtitle' | translate }}</p>
          </div>
          <div class="flex flex-col gap-3 w-full">
            <app-button
              [label]="'executables_card_agent_download_windows' | translate"
              icon="pi pi-windows"
              variant="secondary"
              [fullWidth]="true"
              (onClick)="downloadInstaller('windows')">
            </app-button>
            <app-button
              [label]="'executables_card_agent_download_mac' | translate"
              icon="pi pi-apple"
              variant="secondary"
              [fullWidth]="true"
              (onClick)="downloadInstaller('mac')">
            </app-button>
          </div>
        </div>


        <div class="group relative bg-white rounded-[2.5rem] p-8 border border-slate-100 shadow-sm hover:shadow-md transition-all flex flex-col items-center gap-8">
          <div class="w-20 h-20 bg-primary/5 rounded-3xl shadow-sm flex items-center justify-center border border-primary/10 group-hover:scale-110 transition-all duration-500">
            <svg class="w-10 h-10 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
          </div>
          <div class="text-center flex flex-col gap-2">
            <p class="text-lg font-bold text-slate-800 leading-tight">{{ 'executables_government_middleware' | translate }}</p>
            <p class="text-[10px] text-slate-400 font-bold uppercase tracking-widest bg-slate-50 px-3 py-1 rounded-full border border-slate-100 w-fit mx-auto">{{ 'executables_government_middleware_subtitle' | translate }}</p>
          </div>
          
          <app-button
            [label]="'download' | translate"
            icon="pi pi-download"
            variant="secondary"
            [fullWidth]="true"
            (onClick)="downloadGovernmentMiddleware()">
          </app-button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modals -->
  <div *ngIf="showAddExecutableModal || showEditExecutableModal" class="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fadeIn">
    <div class="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-lg overflow-hidden animate-zoomIn">
      <div class="p-10">
        <div class="flex items-center justify-between mb-10">
          <h2 class="text-xl font-bold text-slate-800">{{ (showAddExecutableModal ? ('executables_modal_add_title' | translate) : ('executables_modal_edit_title' | translate)) }}</h2>
          <button (click)="closeModals()" class="p-2 hover:bg-slate-50 rounded-full transition-all text-slate-400 hover:text-slate-600">
            <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>
        
        <div class="flex flex-col gap-8">
          <div class="flex flex-col gap-2">
            <label class="text-[10px] font-black uppercase tracking-widest text-slate-500">{{ 'executables_field_name' | translate }}</label>
            <input [(ngModel)]="executableForm.title" type="text" pInputText [placeholder]="'executables_field_name_placeholder' | translate" class="w-full !bg-slate-50 !border-slate-100 !rounded-2xl !text-sm focus:!ring-4 focus:!ring-primary/10 focus:!border-primary !transition-all">
          </div>
          
          <div class="flex flex-col gap-2">
            <label class="text-[10px] font-black uppercase tracking-widest text-slate-500">{{ 'executables_field_path' | translate }}</label>
            <div class="relative">
              <input [(ngModel)]="executableForm.path" type="text" pInputText [placeholder]="'executables_field_path_placeholder' | translate" class="w-full !bg-slate-50 !border-slate-100 !rounded-2xl !text-sm !font-mono focus:!ring-4 focus:!ring-primary/10 focus:!border-primary !transition-all pr-12">
              <div class="absolute right-4 top-1/2 -translate-y-1/2 group/hint">
                <svg class="w-5 h-5 text-slate-300 cursor-help" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                <div class="absolute bottom-full right-0 mb-3 w-64 p-4 bg-slate-800 text-white text-[11px] rounded-[1.25rem] opacity-0 invisible group-hover/hint:opacity-100 group-hover/hint:visible transition-all shadow-xl leading-relaxed z-50">{{ 'executables_field_path_hint' | translate }}</div>
              </div>
            </div>
          </div>
          
          <p *ngIf="formError" class="text-[10px] text-rose-500 font-black uppercase tracking-widest bg-rose-50 px-4 py-2 rounded-xl">{{ 'executables_error_required' | translate }}</p>
          
          <div class="flex gap-4 mt-4">
            <app-button label="{{ 'common_cancel' | translate }}" variant="secondary" [fullWidth]="true" (onClick)="closeModals()"></app-button>
            <app-button 
              [label]="showAddExecutableModal ? ('common_add' | translate) : ('common_save_changes' | translate)" 
              variant="primary" 
              [fullWidth]="true" 
              (onClick)="showAddExecutableModal ? saveExecutable() : updateExecutable()">
            </app-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Delete Confirmation Modal -->
  <div *ngIf="showDeleteConfirmModal" class="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fadeIn">
    <div class="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-sm overflow-hidden animate-zoomIn">
      <div class="p-10 text-center flex flex-col gap-8">
        <div class="w-20 h-20 bg-rose-50 rounded-full flex items-center justify-center mx-auto text-rose-500">
          <svg class="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1-1v3M4 7h16" /></svg>
        </div>
        <div class="flex flex-col gap-2">
          <h2 class="text-xl font-bold text-slate-800">{{ 'executables_modal_delete_title' | translate }}</h2>
          <p class="text-sm text-slate-500">{{ 'executables_modal_delete_confirm' | translate }} <span class="font-bold text-slate-700">"{{ selectedExecutable?.executable_title }}"</span>?</p>
        </div>
        <div class="flex gap-4">
          <app-button label="{{ 'common_no' | translate }}" variant="secondary" [fullWidth]="true" (onClick)="closeModals()"></app-button>
          <app-button label="{{ 'common_yes_delete' | translate }}" variant="primary" [fullWidth]="true" (onClick)="deleteExecutable()" styleClass="!bg-rose-500 !hover:bg-rose-600 !border-rose-500"></app-button>
        </div>
      </div>
    </div>
  </div>
</div>
